import { AMBLogo } from "../components/AMBLogo";
import { WhatsAppIcon } from "../components/icons";
import { CONTACT_EMAIL, FOOTER_AREAS, NAV_LINKS, WHATSAPP_DISPLAY, WHATSAPP_URL } from "../data/site";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-white/[0.07] bg-[#05070D] py-16">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <AMBLogo />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-slate-500">
            Ideias estratégicas. Tecnologia que gera resultados.
          </p>
        </div>
        <nav aria-label="Áreas de atuação">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-slate-400">Áreas de atuação</p>
          <ul className="mt-5 space-y-3 text-sm text-slate-500">
            {FOOTER_AREAS.map((a) => (
              <li key={a}>{a}</li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Navegação do rodapé">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-slate-400">Navegação</p>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace("ó", "o")}`} className="text-slate-500 transition-colors duration-300 hover:text-white">
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="inline-flex items-center gap-2 text-[#3a9bff] transition-colors duration-300 hover:text-white"
              >
                <WhatsAppIcon className="h-4 w-4" />
                {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="text-[#3a9bff] transition-colors duration-300 hover:text-white">
                {CONTACT_EMAIL}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-white/[0.06] pt-8 text-xs text-slate-600">
        <p>© 2026 AMB Solutions. Todos os direitos reservados.</p>
        <p className="tracking-[0.3em] uppercase">IA • Automações • Marketing</p>
      </div>
    </div>
  </footer>
);
